import moment from 'moment';

const getters = {
  orgId: state => state.app.orgId,
  orgName: state => state.app.orgName,
  level: state => state.app.orgInfo.level,
  allowLiveReview:state => state.app.orgInfo.liveLookBack===2 || (state.app.orgInfo.liveLookBack===1 && moment().isBefore(state.app.orgInfo.lookBackExpireTime))
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js